import React from "react";
import Table from "./Table/Table";

const MyRegisteredEvents = () => {
  return (
    <div className="content">
      <Table />
    </div>
  );
};

export default MyRegisteredEvents;
